import { IconExtendRegular, NormalButton, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

interface Props {
  isEditRequested: boolean;
  onClickZoom: () => void;
  onEditRequest: () => void;
  setRequestEditButtonRef: (instance: Element | null) => void;
}

export const SizeControl = ({ isEditRequested, onClickZoom, onEditRequest, setRequestEditButtonRef }: Props) => {
  return (
    <ButtonGroup>
      <NormalButton fullWidth variant='tertiaryGray' leftIcon={IconExtendRegular} onClick={onClickZoom}>
        크게 보기
      </NormalButton>
      <GuideText>
        <div>
          <Text variant='Body_14_Multiline_Medium' color='textPrimary'>
            사이즈 정보에 문제가 있나요?
          </Text>
          <Text variant='Caption_12_Multiline_Regular' color='textSecondary' style={{ marginTop: 2 }}>
            AI가 불러온 이미지로, 오류가 있을 수 있어요.
          </Text>
        </div>

        <NormalButton
          ref={setRequestEditButtonRef}
          size='small'
          variant='primary'
          style={{ minWidth: '77px' }}
          disabled={isEditRequested}
          onClick={onEditRequest}
        >
          {isEditRequested ? '요청 완료' : '수정 요청'}
        </NormalButton>
      </GuideText>
    </ButtonGroup>
  );
};

const ButtonGroup = styled.div`
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const GuideText = styled.div`
  padding: 14px 12px 14px 16px;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  border: 1px solid ${vars.v3Color.gray100};
  background: ${vars.v3Color.gray50};
`;
